import React from 'react';
import { Box, Typography } from '@mui/material';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import CloudIcon from '@mui/icons-material/Cloud';
import UmbrellaIcon from '@mui/icons-material/Umbrella';
import FilterDramaIcon from '@mui/icons-material/FilterDrama';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';

function HourWeatherIcon({ hour }) {
  const props = { sx: { fontSize: 18 } };
  if (hour.precipMm >= 0.5) return <UmbrellaIcon {...props} />;
  if (hour.cloudCoverPct >= 60) return <CloudIcon {...props} />;
  if (hour.cloudCoverPct >= 30) return <FilterDramaIcon {...props} />;
  return <WbSunnyIcon {...props} />;
}

const WeatherHourStrip = ({ hours }) => {
  const currentHour = parseInt(
    new Date().toLocaleTimeString('en-US', {
      hour: '2-digit',
      hour12: false,
      timeZone: 'Europe/Warsaw',
    }),
    10,
  );

  return (
    <Box sx={{ display: 'flex', overflowX: 'auto', gap: 1, pb: 1 }}>
      {hours.map((hour) => {
        const isNow = hour.hour === `${String(currentHour).padStart(2, '0')}:00`;
        return (
          <Box
            key={hour.hour}
            sx={{
              minWidth: 68,
              borderRadius: 2,
              border: `1px solid ${isNow ? DEFAULT_THEME_COLOR : 'rgba(0,0,0,0.1)'}`,
              bgcolor: 'white',
              color: 'rgba(0,0,0,0.85)',
              p: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            <Typography
              variant="caption"
              sx={{ fontWeight: 600, opacity: isNow ? 1 : 0.55, fontSize: 10, color: isNow ? DEFAULT_THEME_COLOR : 'inherit' }}
            >
              {hour.hour}
            </Typography>
            <Box sx={{ color: DEFAULT_THEME_COLOR, my: 0.3 }}>
              <HourWeatherIcon hour={hour} />
            </Box>
            <Typography variant="caption" fontWeight={700} sx={{ fontSize: 12 }}>
              {Math.round(hour.tempC)}°C
            </Typography>
            <Typography variant="caption" sx={{ fontSize: 10, opacity: 0.7 }}>
              {hour.precipMm.toFixed(1)} mm
            </Typography>
            <Typography variant="caption" sx={{ fontSize: 10, opacity: 0.7 }}>
              {Math.round(hour.windKmh)} km/h
            </Typography>
            <Typography variant="caption" sx={{ fontSize: 10, opacity: 0.7 }}>
              {Math.round(hour.cloudCoverPct)}%
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default WeatherHourStrip;
